import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { PageHeader, Loader, EmptyState } from "@/components/kit";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";
import { ScrollText } from "lucide-react";

export default function AuditLogs() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/audit-logs").then((r) => setList(r.data)).catch((e) => toast.error(apiError(e))); }, []);
  if (!list) return <Loader />;
  return (
    <div>
      <PageHeader title="Audit Logs" subtitle="Immutable record of critical operations across your scope." />
      {list.length === 0 ? <EmptyState icon={ScrollText} title="No audit records yet" /> : (
        <div className="bg-white rounded-2xl border border-slate-200 overflow-x-auto sf-fade-up">
          <Table>
            <TableHeader><TableRow className="bg-slate-50">
              <TableHead>Time</TableHead><TableHead>User</TableHead><TableHead>Role</TableHead>
              <TableHead>Action</TableHead><TableHead>Entity</TableHead><TableHead>Result</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {list.map((a) => (
                <TableRow key={a.id} data-testid={`audit-row-${a.id}`}>
                  <TableCell className="text-slate-500 text-xs whitespace-nowrap">{new Date(a.timestamp).toLocaleString()}</TableCell>
                  <TableCell className="font-medium text-navy-900">{a.user_name}</TableCell>
                  <TableCell className="text-xs text-slate-500">{a.role}</TableCell>
                  <TableCell><span className="text-xs font-semibold text-navy-800 bg-navy-50 px-2 py-1 rounded-md">{a.action}</span></TableCell>
                  <TableCell className="text-slate-500">{a.entity}</TableCell>
                  <TableCell className="text-xs text-emerald-600 font-medium">{a.result}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
